import React from 'react';
import { Typography } from '@swagup-com/components';
import { Grid, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useRouter } from 'next/router';
import { imageSrcSet, moneyStr } from '../../helpers/utils';
import { useCompany } from '../../hooks';
import { ellipsisStyles } from '../shared/styles/commonStyles';

const useStyles = makeStyles(theme => ({
  swagCardContainer: {
    width: 'fit-content',
    height: 40,
    flexWrap: 'nowrap',
    justifyContent: 'space-around',
    backgroundColor: 'rgba(183, 125, 231, 0.16)',
    borderRadius: 8,
    padding: '6px 6px',
    [theme.breakpoints.down(838)]: {
      display: 'none'
    }
  },
  imageWrapper: {
    width: 40,
    height: 28,
    position: 'relative',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }
  },
  addFundsWrapper: {
    display: 'flex',
    width: 36,
    height: 20,
    justifyContent: 'center',
    borderRadius: 10,
    backgroundColor: '#9846DD',
    padding: '4px 8px'
  },
  addFundsCTA: {
    fontSize: 10,
    letterSpacing: 0.4,
    color: '#ffffff',
    alignSelf: 'center'
  },
  swagCardBalanceText: {
    fontSize: 10,
    fontWeight: 400,
    ...ellipsisStyles
  },
  swagCardBalance: {
    fontSize: 14,
    color: '#9846DD',
    ...ellipsisStyles
  },
  swagCardBalanceContainer: {
    margin: '0px 2px 0px 6px',
    [theme.breakpoints.down(1328)]: {
      display: 'none'
    }
  }
}));

const AddFunds = () => {
  const classes = useStyles();

  return (
    <Link to="/billing/add-credits" className={classes.addFundsWrapper}>
      <Typography variant="body4RegularInter" className={classes.addFundsCTA}>
        ADD
      </Typography>
    </Link>
  );
};

const SwagCardBalanceCntent = () => {
  const company = useCompany();
  const balance = company?.data?.balance || 0;
  const classes = useStyles();
  return (
    <Grid item>
      <Grid container item alignItems="center" justifyContent="center" className={classes.swagCardContainer}>
        <Grid className={classes.imageWrapper}>
          <img srcSet={imageSrcSet('/images/dashboard/swag-card-balance.png')} alt="swag-card-balance" />
        </Grid>
        <Grid item xs={8} className={classes.swagCardBalanceContainer}>
          <Typography variant="body4RegularInter" className={classes.swagCardBalanceText}>
            Swag Card Balance
          </Typography>
          <Typography variant="body4SemiBoldInter" className={classes.swagCardBalance}>
            {moneyStr(balance)}
          </Typography>
        </Grid>
        <Grid item>
          <AddFunds />
        </Grid>
      </Grid>
    </Grid>
  );
};

const SwagCardBalance = () => {
  const isSSR = useRouter();
  if (isSSR) return null;
  return <SwagCardBalanceCntent />;
};

export default SwagCardBalance;
